import React, {useCallback, useMemo, useState} from "react";
import Icon1 from "../../assets/image/icon_company.svg"
import Icon2 from "../../assets/image/check-verified.svg"
import Prev from "../../assets/image/icon_prev.svg";
import {useHistory, useLocation} from "react-router-dom";
import useFetch from "@common/hooks/fetch/useFetch";
import {getJobDetail} from "@common/services/restapi/job";
import moveExternalLink from "@common/utils/app/appBridge";
import {Link, useParams} from "react-router-dom";

function JobDetailView() {

  const history = useHistory();
  const location = useLocation();
  const {category, jobId} = useParams();

  const {data: detailView} = useFetch(() => getJobDetail(category, jobId), [category, jobId], {})

  const handleGoBack = useCallback(() => {
    history.goBack();
  },[])

  console.log(detailView)
  return (
    <div className="job-detail-view">
      <div className="common-header--top">
        <a className="prev-btn" onClick={handleGoBack}>
          <img src={Prev} alt=""/>
        </a>
        <h3 className="header-title">채용정보</h3>
      </div>

      {
        detailView && detailView.job && detailView.corp &&
        <>
          <section className="job-contents">
            <div className="header-box">
              <img src={Icon1} alt=""/>
              <h4 className="title">회사정보</h4>
            </div>
            <ul className="contents-box">
              <li className="row-box">
                <div className="header">회사명</div>
                <div className="content">{detailView.corp.name}</div>
              </li>
              <li className="row-box">
                <div className="header">대표자</div>
                <div className="content">{detailView.corp.president}</div>
              </li>
              <li className="row-box">
                <div className="header">홈페이지</div>
                {
                  detailView.corp.homepage ?
                    <div className="content">
                      <a href={`http://${detailView.corp.homepage}`}
                         target="_blank"
                         onClick={() => moveExternalLink(event, `http://${detailView.corp.homepage}`, '_blank')}
                      >
                        {detailView.corp.homepage}
                      </a>
                    </div>
                    :
                    <div className="content"/>
                }
              </li>
              <li className="row-box">
                <div className="header">회사위치</div>
                <div className="content">{detailView.corp.address2}</div>
              </li>
            </ul>
          </section>

          <section className="job-contents">
            <div className="header-box">
              <img src={Icon2} alt=""/>
              <h4 className="title">모집내용 및 자격조건</h4>
            </div>
            <ul className="contents-box">
              <li className="row-box">
                <div className="header">모집분야</div>
                <div className="content"></div>
              </li>
              <li className="row-box">
                <div className="header">고용형태</div>
                <div className="content">{detailView.job.positionType === 1 ? '정규직' : detailView.job.positionType === 2 ? '계약직' : detailView.job.positionType === 3 ? '인턴' : ''}</div>
              </li>
              <li className="row-box">
                <div className="header">급여조건</div>
                <div className="content">{detailView.job.salary}</div>
              </li>
              <li className="row-box">
                <div className="header">경력제한</div>
                <div className="content">{detailView.job.experienceLevel === 0 ? '무관' : detailView.job.experienceLevel === 1 ? '신입' : detailView.job.experienceLevel === 2 ? "경력 1년이상" : detailView.job.experienceLevel === 3 ? "경력 2년이상" : detailView.job.experienceLevel === 4 ? '경력 3년이상' : detailView.job.experienceLevel === 5 ? '경력 4년이상' : detailView.job.experienceLevel === 6 ? '경력 5년이상' : detailView.job.experienceLevel === 7 ? ' 경력 6년이상' : detailView.job.experienceLevel === 8 ? ' 경력 7년이상' : detailView.job.experienceLevel === 9 ? '경력 8년이상' : detailView.job.experienceLevel === 10 ? '경력 9년이상' : '경력 10년이상'}</div>
              </li>
              <li className="row-box">
                <div className="header">학력제한</div>
                <div className="content">{detailView.job.educationLevel <= 1 ? '무관' : detailView.job.educationLevel >= 2 ? '대학(2,3년)졸업' : detailView.job.educationLevel >= 7 ? '대학 4년제 졸업' : ''}</div>
              </li>
              <li className="row-box">
                <div className="header">근무지역</div>
                <div className="content">{detailView.job.location1 === '0' ? "전국" : detailView.job.location1 === '1' ? "서울" : ""}</div>
              </li>
              <li className="row-box">
                <div className="header">담당업무</div>
                <div className="content">{detailView.job.headline}</div>
              </li>
              <li className="row-box">
                <div className="header">상세요강</div>
                <div className="content" dangerouslySetInnerHTML={{ __html: detailView.job.description }}></div>
              </li>
              <li className="row-box">
                <div className="header">복리후생</div>
                <div className="content">{detailView.job.welfare}</div>
              </li>
              <li className="row-box">
                <div className="header">접수기한</div>
                <div className="content">{detailView.job.applyPeriod === 'F' ? "채용시까지" : ""}</div>
              </li>
              <li className="row-box">
                <div className="header">접수방법</div>
                <div className="content" dangerouslySetInnerHTML={{ __html: detailView.job.applyMethod }}></div>
              </li>
              <li className="row-box">
                <div className="header">담당자</div>
                <div className="content">{detailView.job.contactName}&nbsp;{detailView.job.contactFunc}</div>
              </li>
              <li className="row-box">
                <div className="header">담당자 연락처</div>
                <div className="content">{detailView.job.contactPhone}</div>
              </li>
              <li className="row-box">
                <div className="header">담당자 이메일</div>
                <div className="content">{detailView.job.contactEmail}</div>
              </li>
            </ul>
          </section>
        </>
      }
      </div>
  )
}

export default JobDetailView;
